import { Observer } from "mobx-react-lite";
import React from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { ContextColor } from "../../constants/color.enum";
import { useControllers } from "../../hooks/controller.hooks";
import { useContextColorStyle } from "../../hooks/useContextColor.hook";
import { useObservableRef } from "../../hooks/useObservableRef.hook";
import joinClassName from "../../utils/className.utils";
import { renderRenderable } from "../../utils/components.utils";
import { useProps, useStore } from "../../utils/mobx.utils";
import BaseButton from "../BaseButton/BaseButton";
import './Dialog.scss';
var Dialog = function (props) {
    var p = useProps(props);
    var PORTAL = useControllers().UI.PORTAL;
    var s = useStore(function () { return ({
        dialog: p.dialog,
        config: p.dialog.config,
        get heading() {
            var Heading = s.dialog.config.heading;
            if (typeof Heading === 'function')
                return React.createElement(Heading, null);
            else
                return Heading;
        },
        get body() {
            var Body = s.dialog.config.body;
            if (typeof Body === 'function')
                return React.createElement(Body, null);
            else
                return Body;
        },
        get actions() {
            return s.dialog.actions;
        },
        get someWaiting() {
            return s.actions.some(function (a) { return a.waiting; });
        },
    }); });
    var style = useContextColorStyle(ContextColor.Primary, p.dialog.config.color);
    var ref = useObservableRef();
    useHotkeys('enter', function () {
        if (!ref.current)
            return;
        var positiveButton = ref.current.querySelector("[data-name=\"positive\"]") ||
            ref.current.querySelector("[title=\"OK\"]") ||
            ref.current.querySelector("[title=\"Confirm\"]") ||
            ref.current.querySelector(".DialogFooter .BaseButton:only-child");
        if (positiveButton)
            positiveButton.click();
    });
    useHotkeys('escape', function () {
        if (!ref.current)
            return;
        var negativeButton = ref.current.querySelector("[data-name=\"negative\"]") ||
            ref.current.querySelector("[title=\"Cancel\"]") ||
            ref.current.querySelector("[title=\"No\"]") ||
            ref.current.querySelector(".DialogFooter .BaseButton:only-child");
        if (negativeButton)
            negativeButton.click();
    });
    return React.createElement(Observer, { children: function () { return (PORTAL.render(React.createElement("section", { className: joinClassName("DialogLayer", s.dialog.status, s.dialog.config.colorCodedState && "state-" + s.dialog.config.colorCodedState), "data-dialog-name": s.dialog.config.name, "data-cy": s.dialog.config.dataCy, style: style, ref: ref },
            React.createElement("span", { className: "DialogBackdrop" }),
            React.createElement("div", { className: "Dialog", style: { maxWidth: s.config.width } }, s.dialog.config.customComponent ? renderRenderable(s.dialog.config.customComponent) : React.createElement(React.Fragment, null,
                s.heading && React.createElement("header", { className: "DialogHeader" },
                    React.createElement("h1", { className: "DialogHeading" }, s.heading)),
                s.body && React.createElement("div", { className: "DialogBody" }, s.body),
                React.createElement("footer", { className: "DialogFooter" }, s.actions.map(function (a) { return (React.createElement(BaseButton, { onClick: a.action, key: a.id, appearance: a.buttonAppearance, loading: a.waiting, disabled: a.disabled || s.someWaiting, className: a.buttonClass, color: a.color, name: a.name || a.label, title: a.label || a.name, dataCy: a.dataCy, label: a.label })); }))))))); } });
};
export default Dialog;
